import React from 'react';

export default class Redirect extends React.Component {
  componentDidMount() {
    window.location.href = this.props.loc;
  }

  render() {
    return (
    <div>
      <h1>Redirecting...</h1>
      <p>
        <a href={this.props.loc}>
          Click here if you are not redirected automatically.
        </a>
      </p>
    </div>
    );
  }
}